import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BilldaLogo } from '@billda/shared-ui';
import { APPBAR_HEIGHT } from '../TopAppBar';
import { useOrganization } from '../../../../features/organisation/hooks/useOrganization';

interface SidebarHeaderProps {
  onAction: () => void;
  showClose?: boolean;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  onAction,
  showClose = false,
}) => {
  const { data: orgData } = useOrganization();
  const orgName = orgData?.currentOrganisation?.name;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        pl: 2,
        pr: 1,
        height: APPBAR_HEIGHT,
        flexShrink: 0,
      }}
    >
      <Box sx={{ flexShrink: 0, ml: '-4.5px' }}>
        <BilldaLogo variant="icon" width={24} alt="Billda" />
      </Box>
      <Typography
        variant="body2"
        noWrap
        sx={{
          ml: 1,
          fontWeight: 600,
          color: 'text.primary',
        }}
      >
        {orgName || 'Billda'}
      </Typography>
      {showClose && (
        <IconButton
          onClick={onAction}
          data-testid="expanded-sidebar-close"
          size="small"
          sx={{
            ml: 'auto',
            color: 'text.secondary',
            '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
          }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Box>
  );
};
